import { Box, Heading, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { useAiPlanTitle, useTitleKey } from '../../hooks';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { AiPlanTitleLoading } from './AiPlanTitleLoading';
import s from './PageTitle.scss';
import { useDomainNamePageTitle } from './useDomainNamePageTitle';

export interface PageTitleProps {
  dataHook?: string;
}

export const PageTitle = ({ dataHook }: PageTitleProps) => {
  const { Trans } = EclipsePackagePickerModule.internals.useTranslations();
  const { key, params, isLoading: isTitleKeyLoading } = useTitleKey();
  const { aiTitle, isLoading: isAiTitleLoading } = useAiPlanTitle();
  const domainContent = useDomainNamePageTitle(key);

  // While the AI plan copy is being generated, show the loading title with
  // animated dots instead of a plain skeleton - it reuses the exact `.title`
  // typography of the resolved heading below, so there's no size jump when
  // the real title swaps in.
  if (isAiTitleLoading) {
    return (
      <Box align="center" width="100%" textAlign="center" dataHook={dataHook}>
        <AiPlanTitleLoading />
      </Box>
    );
  }

  if (isTitleKeyLoading) {
    return (
      <Box align="center" width="100%" textAlign="center" dataHook={dataHook}>
        <SkeletonRectangle height="54px" width="400px" />
      </Box>
    );
  }

  return (
    <Box
      align="center"
      width="100%"
      textAlign="center"
      margin="0 auto"
      dataHook={dataHook}
    >
      <Heading className={s.title} size="large">
        {domainContent ?? aiTitle ?? <Trans i18nKey={key} values={params} />}
      </Heading>
    </Box>
  );
};
